import type { Dayjs, ConfigType } from 'dayjs';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

/**
 * Convert UTC time to local time as a Dayjs object.
 * @param config The UTC time to convert.
 * @param format The optional format of the config argument.
 * @returns The local time as a Dayjs object.
 */
export function localizeTime(config: ConfigType, format?: string): Dayjs {
    return dayjs.utc(config, format).local();
}
